<i2a-profile-alert-base-modal [manualDescriptionKey]="'applyCorrection.user.device.manual.description'"
  [manualLinkKey]="'applyCorrection.user.device.manual.link'"
  [automaticDescriptionKey]="'applyCorrection.user.device.automatic.description'" [validation]="validation"
  [ignoreCommentToSend]="session.IgnoreCommentToSend" [displayComment]="session.DisplayComment" [canSend]="canSend"
  [modalTitle]="'profile.confirmationOfInformationTitle' | i18next " [user]="user"
  [disableManualRemediation]="disableManualRemediation">

  <ng-container header-picto>
    <i2a-badge-icon>
      <ng-container icon>
        <fa-icon [icon]="['fal', 'mobile']" size="lg"></fa-icon>
      </ng-container>
    </i2a-badge-icon>
  </ng-container>

  <ng-container header-title>
    {{'profile.user.device.title' | i18next }}<br>
  </ng-container>

  <ng-container body>
    <div class="container-fluid">
      <div class="row pt-3">
        <div class="col">
          <span *ngIf="selectednotRegisteredDevices && selectednotRegisteredDevices.length > 0"
            class="device-name float-left">{{ 'profile.user.device.reportToBeConfirmed' | i18next}}</span>
          <table class="table table-sm id-table mt-2">
            <tbody>
              <tr *ngFor="let selectedDevice of selectednotRegisteredDevices">
                <td scope="row">
                  <i2a-input-checkbox [(model)]="selectedDevice.checked"
                    (modelChange)="notRegisteredChecked($event, selectedDevice)"
                    [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="true"
                    [valueUnChecked]="false"> </i2a-input-checkbox>
                </td>
                <td scope="row" class="text-break w-100">
                  <img [src]="selectedDevice.image" width="24" height="24" />
                  {{selectedDevice.name}}
                </td>
              </tr>
            </tbody>
          </table>

          <span *ngIf="selectedDevices && selectedDevices.length > 0"
            class="device-name float-left">{{ 'profile.user.device.reportUsualDevices' | i18next}}</span>
          <table class="table table-sm id-table mt-2">
            <tbody>
              <tr *ngFor="let selectedDevice of selectedDevices">
                <td scope="row">
                  <i2a-input-checkbox [(model)]="selectedDevice.checked" (modelChange)="checked($event, selectedDevice)"
                    [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="true"
                    [valueUnChecked]="false"> </i2a-input-checkbox>
                </td>
                <td scope="row" class="text-break w-100">
                  <img [src]="selectedDevice.image" width="24" height="24" />
                  {{selectedDevice.name}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-container>

</i2a-profile-alert-base-modal>